<template>
  <AuthGuard>
    <v-container class="account-edit-view w-full pa-4 pa-md-6" max-width="500px">
      <PageHeader
        :title="pageTitle"
        back-to-label="Customer profile"
        :show-back="true"
        :back-to="URLs.PAGE_CUSTOMER_EDIT(customerId ?? '')"
        compact
      />

      <v-card v-if="accountInfo">
        <Loading v-if="state.accountListLoading" />
        <v-card-text v-else>
          <GoogleSearchConsoleAccountEditForm
            :account-id="sourceId!"
            v-if="accountInfo.feed == IApp.IFeedTypes.GoogleSearchConsole"
          />
          <BirdEyeAccountEditForm
            :account-id="sourceId!"
            v-else-if="accountInfo.feed == IApp.IFeedTypes.BirdEye"
          />
          <GoogleAnalyticsAccountEditForm :account-id="sourceId!" v-else />
        </v-card-text>
      </v-card>
      <Loading v-else message="Loading source information..." />
    </v-container>
  </AuthGuard>
</template>

<script setup lang="ts">
import { useAccountStore } from "@/stores/account";
import { IApp } from "@/types";
import { getFeedNameFromFeedType } from "@/utils";
import { computed, onMounted, ref } from "vue";
import Loading from "@/components/Widgets/Loading.vue";
import useRouteParams from "@/hooks/useRouteParams";
import AuthGuard from "@/components/Auth/AuthGuard.vue";
import { useAuthStore } from "@/stores/auth";
import PageHeader from "@/components/PageHeader.vue";
import { URLs } from "@/constants";

import BirdEyeAccountEditForm from "@/components/Account/BirdEyeAccountEditForm.vue";
import GoogleSearchConsoleAccountEditForm from "@/components/Account/GoogleSearchConsoleAccountEditForm.vue";
import GoogleAnalyticsAccountEditForm from "@/components/Account/GoogleAnalyticsAccountEditForm.vue";

const authStore = useAuthStore();
const user = computed(() => authStore.user);

const state = ref({
  accountListLoading: false
});

const accountStore = useAccountStore();

const { customerId, sourceId } = useRouteParams();

const accountInfo = computed(() => {
  if (user.value) {
    return accountStore.getAccountInfo(customerId.value!, sourceId.value!);
  } else {
    return undefined;
  }
});

const pageTitle = computed(() => {
  if (accountInfo.value) {
    return `Edit ${getFeedNameFromFeedType(accountInfo.value.feed)} account`;
  }
  return "Edit account";
});

onMounted(async () => {
  state.value.accountListLoading = true;
  if (user.value?.id && customerId.value) {
    await accountStore.fetchAccountList(user.value?.id!, customerId.value!);
  }
  state.value.accountListLoading = false;
});
</script>
